import React, { useContext, useState, useEffect } from "react";
import { doSystemDateRetrieval } from "common/api";
import BqnContext from "common/BqnContext";

export function calculateTimeOffset(mode, bqnId) {
  return doSystemDateRetrieval(mode, bqnId).then((response) => {
    const systemDate = new Date(response.split(" ").splice(0, 5).join(" "));
    return systemDate.getHours() - new Date().getHours();
  });
}

// The offset is the one of the BQN selected in the header.
export function useTimeOffset() {
  const [timeOffset, setTimeOffset] = useState();
  const { bqnId, clusterStatus } = useContext(BqnContext);
  const mode = clusterStatus?.mode;
  useEffect(() => {
    if (bqnId === undefined) {
      return;
    }

    calculateTimeOffset(mode, bqnId).then((result) => {
      setTimeOffset(result);
    });
  }, [mode, bqnId]);

  return { timeOffset };
}
